var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202,
    height: 64,
    viewBox: "0 0 202 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24534",
    "data-name": "\\uC0AC\\uAC01\\uD615 24534",
    width: 181.333,
    height: 42.001,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19289",
    "data-name": "\\uADF8\\uB8F9 19289",
    transform: "translate(-239 849)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24985",
    "data-name": "\\uC0AC\\uAC01\\uD615 24985",
    width: 202,
    height: 64,
    transform: "translate(239 -849)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14301",
    "data-name": "\\uADF8\\uB8F9 14301",
    transform: "translate(249 -838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14300",
    "data-name": "\\uADF8\\uB8F9 14300",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7306",
    "data-name": "\\uD328\\uC2A4 7306",
    d: "M69.983,23.547h5.952l2.824-8.527a2.806,2.806,0,0,0-2.664-3.687H56.514a1.7,1.7,0,0,1,1,2.058q0,.215-3.319,10.155h5.965l1.328-4.05H71.32Zm2.163-6.572h-9.82l.493-1.505a2.243,2.243,0,0,1,2.133-1.547h7.041a.841.841,0,0,1,.8,1.1Z",
    transform: "translate(16.994 3.554)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7307",
    "data-name": "\\uD328\\uC2A4 7307",
    d: "M86.6,20.959H78.75l2.219-6.677a2.244,2.244,0,0,0-2.131-2.948H74.186a1.456,1.456,0,0,1,1.127,2.02L71.944,23.548H91.97l-2.051-1.5A5.6,5.6,0,0,0,86.6,20.959",
    transform: "translate(22.561 3.554)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7308",
    "data-name": "\\uD328\\uC2A4 7308",
    d: "M120.677,11.334s1.7.687,1.22,2.12l-1.827,5.514a2.8,2.8,0,0,1-2.663,1.923h-5.093a.844.844,0,0,1-.8-1.107l1.818-5.5a2.242,2.242,0,0,0-2.129-2.948h-4.733a1.648,1.648,0,0,1,1.141,2.07l-2.322,7.2a2.246,2.246,0,0,0,2.136,2.953l2.847-.007h10.186a5.612,5.612,0,0,0,5.337-3.875l1.789-5.386a2.242,2.242,0,0,0-2.129-2.952Z",
    transform: "translate(32.981 3.554)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_4",
    "data-name": "\\uC120 4",
    x2: 0.003,
    y2: 0.001,
    transform: "translate(152.546 22.734)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7309",
    "data-name": "\\uD328\\uC2A4 7309",
    d: "M110.371,11.334h-16.5A5.046,5.046,0,0,0,89.08,14.8l-1.918,5.811a2.242,2.242,0,0,0,2.132,2.948h19.1l1.691-5.173a1.684,1.684,0,0,0-1.6-2.207h-6.925A5.611,5.611,0,0,0,98.2,17.3L96.33,18.7h7.695l-.675,2.057-9.108,0a.84.84,0,0,1-.8-1.106l1.35-4.063a2.243,2.243,0,0,1,2.129-1.538h7.937a5.618,5.618,0,0,0,3.355-1.113Z",
    transform: "translate(27.297 3.554)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7310",
    "data-name": "\\uD328\\uC2A4 7310",
    d: "M40.436,11.334H60.552V11.4a8.391,8.391,0,0,1-6.324,2.523l-3.172,9.623H45.1l3.167-9.623c-3.682,0-6-.842-7.83-2.523Z",
    transform: "translate(12.68 3.554)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7311",
    "data-name": "\\uD328\\uC2A4 7311",
    d: "M142.846,11.334H122.73V11.4a8.385,8.385,0,0,0,6.321,2.523h.147l-3.168,9.623h5.957l3.172-9.623h-.147c3.685,0,6-.842,7.834-2.523Z",
    transform: "translate(38.487 3.554)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7312",
    "data-name": "\\uD328\\uC2A4 7312",
    d: "M37.234,7.691l-3.455,4.516a15.651,15.651,0,1,1-3.528-3.644l4.521-3.4a20.958,20.958,0,1,0,2.462,2.527",
    transform: "translate(0 0)",
    fill: "#38748f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7313",
    "data-name": "\\uD328\\uC2A4 7313",
    d: "M32.472,5.221,28.013,8.575,9.811,22.264H21.2l8.854-11.571,3.409-4.456,3.176-4.152Z",
    transform: "translate(3.077 0.654)",
    fill: "#ff5200"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/MainLogo.40186e02a98657aed741ca0ee54c87be.svg";
export { ForwardRef as ReactComponent };